<template>
  <div class="container__forum-comment-like">
    <b-button ref="button__like" variant="transparent" class="button__like p-0" @click="actionLike">
      <font-awesome-icon
        v-if="isLiked"
        ref="button__like-icon-like"
        :icon="{ prefix: 'fas', iconName: 'heart' }"
        style="color: var(--primary)"
      />

      <font-awesome-icon
        v-else
        ref="button__like-icon-unlike"
        :icon="{ prefix: 'far', iconName: 'heart' }"
      />
      <span ref="text__like-amount" class="ml-2" v-text="countLike"></span>
    </b-button>
  </div>
</template>

<script>
import { faHeart as faSolidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faRegularHeart, faMessage } from '@fortawesome/free-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faSolidHeart, faRegularHeart, faMessage);

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    countLike: {
      type: Number,
      default: 0
    }
  },

  computed: {
    isLiked() {
      return this.content;
    }
  },
  methods: {
    async actionLike() {
      this.$emit('click:liked', this.content);
    }
  }
};
</script>

<style lang="scss" scoped>
.container__forum-comment-like {
  .btn:focus {
    box-shadow: none !important;
  }
}
</style>
